import { LEAVE_ROLE } from '@/utils/constUtils'

export default [
  {
    path: '/vehiclemanage/index',
    name: 'PageVehicleIndex',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/PageVehicleIndex'
      ),
    meta: {
      modular: 95,
      title: '智慧停车',
      info: '智慧停车——首页',
      keepAlive: true
    }
  },
  {
    path: '/vehiclemanage/index/calendar',
    name: 'pageVehicleCalendar',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleCalendar'
      ),
    meta: {
      modular: 95,
      title: '停车记录',
      info: '智慧停车——停车记录',
      keepAlive: true
    }
  },
  {
    path: '/vehiclemanage/index/settingdaterules',
    name: 'pagVehicleDateRules',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pagVehicleDateRules'
      ),
    meta: {
      modularObj: {
        [`${LEAVE_ROLE.teacher}`]: 95,
        [`${LEAVE_ROLE.guardian}`]: 95
      },
      field: 'ruleType',
      infoObj: {
        [`${LEAVE_ROLE.teacher}`]: '智慧停车——通行规则',
        [`${LEAVE_ROLE.guardian}`]: '智慧停车——通行规则'
      },
      titleObj: {
        [`${LEAVE_ROLE.teacher}`]: '通行规则-教师车辆',
        [`${LEAVE_ROLE.guardian}`]: '通行规则-家长车辆'
      },
      keepAlive: true
    }
  },
  {
    path: '/vehiclemanage/index/settingdaterules/timestage',
    name: 'pageVehicleTimeStage',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleTimeStage'
      ),
    meta: {
      modular: 95,
      title: '可通行时间',
      info: '智慧停车——可通行时间'
    }
  },
  {
    path: '/vehiclemanage/index/settingparkinglot',
    name: 'PageVehicleSettingParkingLot',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/PageVehicleSettingParkingLot'
      ),
    meta: {
      modular: 95,
      title: '车场信息',
      info: '智慧停车——车场信息'
    }
  },
  {
    path: '/vehiclemanage/index/settingovertime',
    name: 'pageVehicleOverTime',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleOverTime'
      ),
    meta: {
      modular: 95,
      title: '家长超时停车',
      info: '智慧停车——家长超时停车'
    }
  },
  {
    path: '/vehiclemanage/index/settingblacklist',
    name: 'pageVehicleBlackList',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleBlackList'
      ),
    meta: {
      modular: 95,
      title: '黑名单',
      info: '智慧停车——黑名单'
    }
  },
  {
    path: '/vehiclemanage/index/settingblacklist/add',
    name: 'pageVehicleAddBlack',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleAddBlack'
      ),
    meta: {
      modular: 95,
      title: '黑名单',
      info: '智慧停车——添加黑名单'
    }
  },
  {
    path: '/vehiclemanage/index/settingboardnumber',
    name: 'pageVehicleBoardNumber',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleBoardNumber'
      ),
    meta: {
      modular: 95,
      title: '剩余停车位',
      info: '智慧停车——剩余停车位'
    }
  },
  // 用于外链跳转
  {
    path: '/vehiclemanage/board/number',
    name: 'pageVehicleBoardNumber',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleBoardNumber'
      ),
    meta: {
      modular: 95,
      title: '剩余停车位',
      info: '智慧停车——剩余停车位'
    }
  },
  {
    path: '/vehiclemanage/index/notice',
    name: 'pageVehicleNotice',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleNotice'
      ),
    meta: {
      modular: 95,
      title: '通知配置',
      info: '智慧停车——通知配置'
    }
  },
  {
    path: '/full/vehiclemanage/index/notice/detail',
    alias: '/full/vehiclemanage/noticeDetail',
    name: 'pageVehicleNoticeDetail',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleNoticeDetail'
      ),
    pathType: 'keep',
    meta: {
      modular: 95,
      title: '通知配置',
      info: '智慧停车——通知配置详情'
    }
  },
  {
    path: '/gray/vehiclemanage/index/notice/detail',
    alias: '/gray/vehiclemanage/noticeDetail',
    name: 'pageVehicleNoticeDetail',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleNoticeDetail'
      ),
    pathType: 'keep',
    meta: {
      modular: 95,
      title: '通知配置',
      info: '智慧停车——通知配置详情'
    }
  },
  {
    path: '/vehiclemanage/index/managedetail',
    name: 'PageVehicleManageDetail',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/PageVehicleManageDetail'
      ),
    meta: { modular: 95, title: '新增车辆', info: '智慧停车——新增车辆' }
  },
  {
    path: '/vehiclemanage/manage/detail',
    name: 'PageVehicleManageDetail',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/PageVehicleManageDetail'
      ),
    meta: { modular: 95, title: '新增车辆', info: '智慧停车——新增车辆' }
  },
  {
    path: '/vehiclemanage/index/notice/manage',
    name: 'PageVehicleManageNotice',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/PageVehicleManageNotice'
      ),
    meta: {
      modular: 95,
      title: '通知录入车牌',
      info: '智慧停车——通知录入车牌'
    }
  },
  {
    path: '/vehiclemanage/index/expired',
    name: 'pageVehicleExpired',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleExpired'
      ),
    meta: { modular: 95, title: '新增车辆', info: '新增车辆' }
  },
  {
    path: '/vehiclemanage/arrive',
    name: 'pageVehicleArrive',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleArrive'
      ),
    meta: { modular: 97, title: '开车接送', info: '开车接送' }
  },
  {
    path: '/vehiclemanage/apply',
    name: 'pageVehicleApply',
    component: () =>
      import(
        /* webpackChunkName: "vehicleManage" */ '../pages/vehiclemanage/pageVehicleApply'
      ),
    meta: { modular: 97, title: '车辆进入学校申请', info: '车辆进入学校申请' }
  }
]
